;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .controller('VulnSummaryCtrl', VulnSummaryCtrl)

  function VulnSummaryCtrl(
    $scope,
    $controller,
    $routeParams,
    logger,
    permissions,
    confirmModal,
    appTracesApiConfig,
    LoadFilterRouteService,
    traceRenderService,
    VulnerabilitiesService,
    ErrorService,
    ORG_VULN_EVENTS,
    SUBFILTERS
  ) {
    'ngInject'

    this.$onInit = function () {
      angular.extend($scope, {
        propertyOpen: {},
        propertiesOpen: 0
      })

      angular.extend($scope, {
        deleteProperty: deleteProperty,
        goToAppVulns: goToAppVulns,
        getMostPermissiveRole: getMostPermissiveRole
      })

      init()
    }

    function init() {
      var ctrlBase = $controller('BaseVulnSummaryCtrl', { $scope: $scope })
      ctrlBase.$onInit()

      // Extend model because this is inheriting scope
      angular.extend($scope.model, {
        showApp: angular.isUndefined($routeParams.appId),
        orgId: $routeParams.orgUuid
      })

      $scope.$on('traces:overview:load', function () {
        //Window of Exposure
        $scope.model.trace = VulnerabilitiesService.formatTraceDates(
          $scope.model.trace
        )
        //environments
        $scope.model.environments = VulnerabilitiesService.formatEnvironments(
          $scope.model.trace
        )

        traceRenderService.getTraceStory($scope, $scope.getTraceUuid())
      })

      _emitTraceActiveEvent()

      if ($scope.model.trace && !$scope.model.environments) {
        //Window of Exposure
        $scope.model.trace = VulnerabilitiesService.formatTraceDates(
          $scope.model.trace
        )
        //environments
        $scope.model.environments = VulnerabilitiesService.formatEnvironments(
          $scope.model.trace
        )

        traceRenderService.getTraceStory($scope, $scope.getTraceUuid())
      }
    }

    function _emitTraceActiveEvent() {
      var eventName = ORG_VULN_EVENTS.ORG_TRACE_ACTIVE
      if ($routeParams.serverId) {
        eventName = ORG_VULN_EVENTS.SERVER_TRACE_ACTIVE
      } else if ($routeParams.appId) {
        eventName = ORG_VULN_EVENTS.APP_TRACE_ACTIVE
      }
      $scope.$emit(eventName, { active: 'summary' })
    }

    function deleteProperty(traceId, propName) {
      confirmModal
        .open({
          title: 'Please Confirm',
          message: 'Are you sure you want to delete this property?',
          dialogOptions: {
            size: 'sm',
            yes: 'Delete'
          }
        })
        .then(function (confirmed) {
          if (confirmed) {
            appTracesApiConfig
              .deleteProperty(traceId, propName)
              .then(function (response) {
                if (
                  Object.keys($scope.model.chapters[0].properties).length <= 1
                ) {
                  VulnerabilitiesService.moveToVulnPage()
                } else {
                  $scope.$emit(ORG_VULN_EVENTS.LOAD_TITLE, {})
                  logger.logSuccess(response.data.messages[0])
                  traceRenderService.getTraceStory(
                    $scope,
                    $scope.getTraceUuid()
                  )
                }
              })
              .catch(ErrorService.processError)
          }
        })
    }

    function goToAppVulns(appId, env) {
      var filters = {}
      filters[SUBFILTERS.VULNS.ENUM.SERVER_ENVIRONMENT] = [env.toString()]
      LoadFilterRouteService.goToApplicationVulnerabilities(filters, appId)
    }

    function getMostPermissiveRole() {
      return permissions.getMostPermissiveRole()
    }
  }
})()
